export default {
    async asyncForEach(array, callback) {
        for (let index = 0; index < array.length; index++) {
            await callback(array[index], index, array);
        }
    },

    formatValue(value, format) {
        if (format === 'd/m/Y') {
            const date = new Date(value);
            return [date.getDay(), date.getMonth() + 1, date.getFullYear()].join('/');
        }

        if (format === 'D/M/Y') {
            let [D, M, Y] = value.split(/\D/);
            return new Date(Y, M-1, D);
        }

        if (format === 'percent') {
            return value + '%';
        }

        if (format.append) {
            return value + format.append;
        }

        if (format.type && format.type === 'time') {
            if (format.time && format.time.unit) {
                if (format.time.unit === 'year') {
                    const date = new Date(value);
                    return date.getFullYear();
                }
            }
        }

        return value;
    }
};
